import { render, staticRenderFns } from "./RelationsModal.vue?vue&type=template&id=9f3b7f7e&"
import script from "./RelationsModal.vue?vue&type=script&lang=js&"
export * from "./RelationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports